<p [innerHTML]="'HOME.MODAL.SUPPORT.PARAGRAPH1' | translate"></p>
<br />
<p [innerHTML]="'HOME.MODAL.SUPPORT.PARAGRAPH2' | translate"></p>
<br />
<form [formGroup]="supportModalForm">
    <app-generic-radio-checkbox
        [config]="{
            inputType: 'checkbox',
            formGroupName: 'hideSupport',
            questionChoices: [
                {
                    label: 'HOME.MODAL.SUPPORT.CHECKBOX_LABEL',
                    value: true
                }
            ]
        }"
        formControlName="hideSupport"
    ></app-generic-radio-checkbox>
</form>
